module.exports = __webpack_public_path__ + "img/sec1_button_choice.d0cd44fc.jpg";